import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/faq';

export default function FaqPreview() {
  const [open, setOpen] = useState<number | null>(0);
  const preview = faqs.slice(0, 5);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <span className="text-sm font-semibold tracking-wide text-primary-600">常见问题</span>
        <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">追更收藏，有问必答</h2>
        <p className="mt-4 text-foreground-600">关于更新提醒、收藏与进度保存的常见疑问，这里都有答案。</p>
      </div>

      <div className="mx-auto mt-10 max-w-3xl divide-y divide-background-200 rounded-2xl border border-background-200/70 bg-background-50 px-5 md:px-8">
        {preview.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={f.q}>
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                className="flex w-full items-center justify-between gap-4 py-5 text-left"
                aria-expanded={isOpen}
              >
                <span className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-foreground-600 transition-transform ${
                    isOpen ? 'rotate-180 bg-primary-100 text-primary-700' : 'bg-background-100'
                  }`}
                >
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>
              {isOpen && (
                <p className="pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-8 text-center">
        <Link
          to="/faq"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300/70 px-6 py-3 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-700"
        >
          查看更多常见问题
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}